import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Zoom from '@material-ui/core/Zoom';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { useLanguage, LanguageLink } from '@hilma/netina2all';

import { useI18n, useSettings } from '../hooks';
import { Button } from '../components';

interface FooterProps {
	showShoppingCart?: boolean;
}

let timer: NodeJS.Timeout;

const Footer: React.FC<FooterProps> = ({ showShoppingCart = true }) => {
	const [isScolling, setIsScolling] = useState(false);

	const { showPurchaseButton } = useSettings();

	const footer = useI18n(i18n => i18n.footer);
	const alts = useI18n(i18n => i18n.alts);
	const topbar = useI18n(i18n => i18n.topbar)

	const language = useLanguage();

	const mediaQuery = useMediaQuery('(pointer:none), (pointer:coarse), screen and (max-width: 67rem)');
	const location = useLocation();

	const purchaseButton = useMemo(() => {
		return showPurchaseButton && !['purchase', 'profile'].includes(location.pathname.split('/')[2]);
	}, [showPurchaseButton, location.pathname]);

	useEffect(() => {
		if (mediaQuery && showShoppingCart !== false) {
			document.addEventListener('scroll', onScroll);
		}
		return () => {
			document.removeEventListener('scroll', onScroll);
		}
	}, [mediaQuery, showShoppingCart]);

	function onScroll() {
		setIsScolling(true);

		clearTimeout((timer as NodeJS.Timeout));

		timer = setTimeout(() => {
			setIsScolling(false);
		}, 300);
	}

	return (
		<footer>
			<div className='footer-container'>
				<LanguageLink to="/">
					<img className='footer-logo' src='/lulav-icons/logo.svg' alt={alts.latetLogo} />
				</LanguageLink>

				{!mediaQuery && <div className='hilma'>
					<a href='https://www.hilma.tech/' target='_blank' rel='noreferrer'><img src='/lulav-icons/made-by-hilma.png' /></a>
				</div>}

				<div className='flex-empty-space'></div>
				{purchaseButton ?
					<Button to='/purchase' >{footer.alsoPurchase}</Button>
					: null}
				{mediaQuery ? <img src='/lulav-icons/made-by-hilma.png' style={{ ...(mediaQuery ? {} : { position: 'absolute' }), height: '25px' }} /> : <a href='https://www.facebook.com/profile.php?id=100089416574000&mibextid=LQQJ4d' target='_blank' rel='noreferrer'>
					<div>{footer.findFB}</div>
					<img className='fb-logo' src='/lulav-icons/facebook.svg' alt={alts.fbIcon} style={language === 'he' ? { marginRight: '5px' } : { marginLeft: '5px' }} />
				</a>}

			</div>
			{mediaQuery && showShoppingCart === true && (
				<Zoom in={!isScolling && purchaseButton || false}>
					<LanguageLink to={purchaseButton ? '/purchase' : '/leave-details'} className='purchase-mobile'>
						{topbar.buy}
						<ShoppingCartIcon titleAccess={alts.purchase} />
					</LanguageLink>
				</Zoom>
			)}
		</footer>
	);
}

export default Footer;